import * as React from "react";
import { LinkIcon } from "@heroicons/react/24/outline";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AddFilesModalContent } from "./content";

interface Props {
  currentFolderId: string;
  isReadOnly?: boolean;
}

export const AddFilesModal: React.FC<Props> = ({ currentFolderId, isReadOnly }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="secondary" borderStyle="border-gray-300 border-solid" type="button" disabled={isReadOnly}>
          <LinkIcon className="mr-2 h-5 w-5" />
          Add Files
        </Button>
      </DialogTrigger>
      {isOpen && <AddFilesModalContent currentFolderId={currentFolderId} setIsOpen={setIsOpen} />}
    </Dialog>
  );
};
